import { render, staticRenderFns } from "./detail2.vue?vue&type=template&id=85a4f454&scoped=true&"
import script from "./detail2.vue?vue&type=script&lang=js&"
export * from "./detail2.vue?vue&type=script&lang=js&"
import style0 from "./detail2.vue?vue&type=style&index=0&id=85a4f454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a4f454",
  null
  
)

export default component.exports